"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.weak-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Map = _interopRequireDefault(require("ol/Map"));

var _Vector = _interopRequireDefault(require("ol/layer/Vector"));

var _Style = _interopRequireDefault(require("ol/style/Style"));

var _Fill = _interopRequireDefault(require("ol/style/Fill"));

var _Circle = _interopRequireDefault(require("ol/style/Circle"));

var _Stroke = _interopRequireDefault(require("ol/style/Stroke"));

var _Geometry = _interopRequireDefault(require("ol/geom/Geometry"));

var _map = require("../../../../util/map");

var _agGridReact = require("ag-grid-react");

var _FeatureGridMenuBar = _interopRequireDefault(require("../../../menuBar/feature/FeatureGridMenuBar/FeatureGridMenuBar"));

var _usePrevious = _interopRequireDefault(require("../../../../hooks/common/usePrevious"));

var _defined = _interopRequireDefault(require("../../../../core/defined"));

require("ag-grid-community/dist/styles/ag-grid.css");

require("ag-grid-community/dist/styles/ag-theme-balham.css");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["map", "vectorLayer", "zoomToLayer", "columnDefs", "rowSelection", "featureStyle", "selectedFeatureStyle", "keyFunc", "className", "onGridReady", "onRowClicked", "onSelectionChanged"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultKeyFunction = function defaultKeyFunction(feature) {
  return feature.ol_uid;
};
/**
 * <p>Component to load the the openlayers features in the grid:</p>
 * <ol>
 *  <li>All the features in the vector layer <i>vectorLayer</i> 
 *      will be loaded in the grid.
 *  </li>
 *  <li>
 *      The <strong>unselected</strong> feature(s) in the row grid will be rendered
 *      using the style defined in <i>featureStyle</i>.
 *  </li>
 *  <li>
 *      The <strong>selected</strong> feature(s) in the row grid will be rendered
 *      using the style defined in <i>selectedFeatureStyle</i>.
 *  </li>
 *  <li>
 *      Addional properties not listed below can be passed. See
 *      <a href="https://www.ag-grid.com/react-grid/grid-properties/">documentation</a> 
 *      for more details.
 *  </li>
 * </ol>
 * 
 * @visibleName Feature Grid
 */


var FeatureGrid = function FeatureGrid(_ref) {
  var map = _ref.map,
      vectorLayer = _ref.vectorLayer,
      _ref$zoomToLayer = _ref.zoomToLayer,
      zoomToLayer = _ref$zoomToLayer === void 0 ? true : _ref$zoomToLayer,
      _ref$columnDefs = _ref.columnDefs,
      columnDefs = _ref$columnDefs === void 0 ? null : _ref$columnDefs,
      _ref$rowSelection = _ref.rowSelection,
      rowSelection = _ref$rowSelection === void 0 ? 'multiple' : _ref$rowSelection,
      _ref$featureStyle = _ref.featureStyle,
      featureStyle = _ref$featureStyle === void 0 ? new _Style.default({
    stroke: new _Stroke.default({
      //color: 'rgba(204, 0, 204, 1.0)',
      color: 'rgba(0, 0, 255, 0.4)',
      width: 2
    }),
    fill: new _Fill.default({
      //color: 'rgba(255, 179, 255, 0.4)'
      color: 'rgba(97, 218, 251, 0.4)'
    }),
    image: new _Circle.default({
      radius: 8,
      fill: new _Fill.default({
        color: 'rgba(97, 218, 251, 1.0)'
      }),
      stroke: new _Stroke.default({
        color: '#000',
        width: 2
      })
    })
  }) : _ref$featureStyle,
      _ref$selectedFeatureS = _ref.selectedFeatureStyle,
      selectedFeatureStyle = _ref$selectedFeatureS === void 0 ? new _Style.default({
    stroke: new _Stroke.default({
      //color: 'rgba(204, 0, 204, 1.0)',
      color: 'rgba(0, 0, 0, 1.0)',
      width: 3
    }),
    fill: new _Fill.default({
      color: 'rgba(0, 0, 255, 0.5)'
    }),
    image: new _Circle.default({
      radius: 10,
      fill: new _Fill.default({
        color: 'rgba(0, 0, 255, 1.0)' //dark magenta (40%)

      }),
      stroke: new _Stroke.default({
        color: '#000',
        width: 2
      })
    }),
    zIndex: 100
  }) : _ref$selectedFeatureS,
      _ref$keyFunc = _ref.keyFunc,
      keyFunc = _ref$keyFunc === void 0 ? defaultKeyFunction : _ref$keyFunc,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'ag-theme-balham' : _ref$className,
      onGridReady = _ref.onGridReady,
      onRowClicked = _ref.onRowClicked,
      onSelectionChanged = _ref.onSelectionChanged,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(columnDefs),
      _useState2 = _slicedToArray(_useState, 2),
      currentColumnDefs = _useState2[0],
      setCurrentColumnDefs = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      _rowData = _useState4[0],
      setRowData = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      _selectedFeatures = _useState6[0],
      setSelectedFeatures = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      _gridApi = _useState8[0],
      setGridApi = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      setGridColumnApi = _useState10[1];

  var previousColumnDefs = (0, _usePrevious.default)(columnDefs);

  if (columnDefs !== previousColumnDefs && columnDefs !== currentColumnDefs) {
    setCurrentColumnDefs(columnDefs);
  }
  /**
   * callback used to pass as attribute for ag-grid
   * to retrieve the row based on a defined id
   * 
   * Usage: const rowNode = gridOptions.api.getRowNode(key);
   */


  var getRowId = (0, _react.useCallback)(function (params) {
    return params.data.key; //usage: var rowNode = gridOptions.api.getRowNode('aa');
  }, []);
  /**
   * Generate the grid row data in json format from
   * all the features present in the array
   * 
   * @param {ol.Feature[]} features The array of features to 
   *                                generate row data drom.
   * @return {Object[]} The array containing the row data
   */

  var buildRowDataFromFeatures = (0, _react.useCallback)(function (features) {
    var data = [];
    features.forEach(function (feature) {
      var properties = feature.getProperties();
      var filtered = Object.keys(properties) //filter out the properties having geometry type
      .filter(function (key) {
        return !(properties[key] instanceof _Geometry.default);
      }).reduce(function (obj, key) {
        obj[key] = properties[key];
        return obj;
      }, {});
      data.push(_objectSpread({
        key: keyFunc(feature),
        __feature: feature
      }, filtered));
    });
    return data;
  }, [keyFunc]);
  /**
  * Generata the grid row data in json format from
  * all the features present in the vector layer
  * 
  * @param {ol.layer.Vector} layer The vector layer
  * @return {Object[]} The array containing the row data
  */

  var buildRowDataFromLayer = (0, _react.useCallback)(function (layer) {
    if (!layer) return [];
    var features = layer.getSource().getFeatures();
    var data = buildRowDataFromFeatures(features);
    return data;
  }, [buildRowDataFromFeatures]);
  /**
   * Event handler to 'propertychange' events of the underlying `ol.Feature`. 
   * All changes on the object will be reflected in the row grid.
   * See: https://www.ag-grid.com/documentation/react/data-update-single-row-cell/
   * 
   * @param {ol.ObjectEvent} evt evt The `ol.ObjectEvent` we receive as handler.
   */

  var onFeaturePropertyChangeHandler = (0, _react.useCallback)(function (evt) {
    //retrieve the changed feature
    var changedFeature = evt.target;
    var propertyName = evt.key;
    var propertyValue = changedFeature.get(propertyName);

    var row = _gridApi.getRowNode(keyFunc(changedFeature));

    if (row) {
      //change the data for the grid row
      if (propertyName in row.data) row.setDataValue(propertyName, propertyValue);
    }
  }, [_gridApi, keyFunc]);
  /**
   * Method to register the feature 'propertychange' event handler in all
   * the features in the array.
   * 
   * @param {ol.Feature[]} features Array of features on which the handler
   *                                will be registered
   */

  var registerFeaturePropertyChange = (0, _react.useCallback)(function (features) {
    features.forEach(function (feature) {
      feature.on('propertychange', onFeaturePropertyChangeHandler);
    });
  }, [onFeaturePropertyChangeHandler]);
  /**
   * Method to unregister the feature 'propertychange' event handler in all
   * the features in the array.
   * 
   * @param {ol.Feature[]} features Array of features on which the handler
   *                                will be unregistered
   */

  var unRegisterFeaturePropertyChange = (0, _react.useCallback)(function (features) {
    features.forEach(function (feature) {
      feature.un('propertychange', onFeaturePropertyChangeHandler);
    });
  }, [onFeaturePropertyChangeHandler]);
  /**
   * Event Handler for the event 'add' fired when a feature is
   * added in the layer.
   * This method will:
   * (a) Add a new row in the data grid
   * (b) register in the added feature the event handler 'propertychange'
   * @param {ol.CollectionEvent} evt The event fired by the layer
   */

  var onFeatureAddHandler = (0, _react.useCallback)(function (evt) {
    //const onFeatureAddHandler = useDynamicCallback((evt) => {
    //retrives the feature and layer on which feature was removed
    var feature = evt.feature; //register 'propertychange' in the added feature

    feature.on('propertychange', onFeaturePropertyChangeHandler); //replace the row data to rebuild the data to refresh the grid.
    //TODO: to check the asyn method for performance:
    //https://www.ag-grid.com/javascript-grid-data-update-high-frequency/
    // _gridApi.updateRowData({add: data});

    var data = buildRowDataFromFeatures([feature]);

    _gridApi.applyTransaction({
      add: data
    }); //refresh the row model


    _gridApi.refreshClientSideRowModel('filter');
  }, [buildRowDataFromFeatures, _gridApi, onFeaturePropertyChangeHandler]); //});

  /**
   * Event Handler for the event 'remove' fired when a feature is
   * removed from the layer.
   * This method will:
   * (a) remove row in the data grid
   * (b) unregister in the removed feature the event handler 'propertychange'
   * @param {ol.CollectionEvent} evt The event fired by the layer
   */

  var onFeatureRemoveHandler = (0, _react.useCallback)(function (evt) {
    //retrives the feature and layer on which feature was removed
    var removedFeature = evt.feature; //unregister 'propertychange' in the added feature

    removedFeature.un('propertychange', onFeaturePropertyChangeHandler); //replace the row data to rebuild the data to refresh the grid.
    //TODO: to check the asyn method for better performance:
    //https://www.ag-grid.com/javascript-grid-data-update-high-frequency/
    //remove the row from the grid

    var row = _gridApi.getRowNode(keyFunc(removedFeature));

    if (!row) return;

    _gridApi.applyTransaction({
      remove: [row.data]
    });
  }, [_gridApi, keyFunc, onFeaturePropertyChangeHandler]);
  /**
   * Event Handler for the event 'clear' fired when the clear is
   * called from the layer source.
   * This method will:
   * (a) remove row in the data grid
   * (b) unregister in the removed feature the event handler 'propertychange'
   * @param {ol.CollectionEvent} evt The event fired by the layer
   */

  var onFeatureSourceClearHandler = (0, _react.useCallback)(function (evt) {
    //replace the row data to rebuild the data to refresh the grid.
    //TODO: to check the asyn method for better performance:
    //https://www.ag-grid.com/javascript-grid-data-update-high-frequency/
    //remove the row from the grid
    //_gridApi.applyTransaction({remove: _rowData});
    _gridApi.setRowData([]);
  }, [_gridApi]);
  /**
   * Method to register the event handlers 'addfeature'
   * and 'removefeature' to handle the cases on which the 
   * feature is added or removed from the layer.
   * @param {ol.layer.Base} layer The layer
   */

  var registerLayerEventHandlers = (0, _react.useCallback)(function (layer) {
    if (layer) {
      //layer.getSource().on('changefeature', onFeatureChangeHandler);
      layer.getSource().on('addfeature', onFeatureAddHandler);
      layer.getSource().on('removefeature', onFeatureRemoveHandler);
      layer.getSource().on('clear', onFeatureSourceClearHandler);
    }
  }, [onFeatureAddHandler, onFeatureRemoveHandler, onFeatureSourceClearHandler]);
  /**
   * Method to unregister the event handlers 'addfeature' 
   * and 'removefeature' to handle the cases on which the 
   * feature is added or removed from the layer.
   * @param {ol.layer.Base} layer The layer.
   */

  var unRegisterLayerEventHandlers = (0, _react.useCallback)(function (layer) {
    if (layer) {
      //layer.getSource().un('changefeature', onFeatureChangeHandler);
      layer.getSource().un('addfeature', onFeatureAddHandler);
      layer.getSource().un('removefeature', onFeatureRemoveHandler);
      layer.getSource().un('clear', onFeatureSourceClearHandler);
    }
  }, [onFeatureAddHandler, onFeatureRemoveHandler, onFeatureSourceClearHandler]);
  /**
   * If the attribute "columnDefs" is not provided for this component,
   * buid the columnDefs based on the properties of the feature
   * in the vector layer
   */

  var buildColumnDefs = (0, _react.useCallback)(function (vectorLayer) {
    if ((!(0, _defined.default)(currentColumnDefs) || currentColumnDefs.length === 0) && (0, _defined.default)(vectorLayer) && vectorLayer.getSource().getFeatures().length > 0) {
      // if((columnDefs.length === 0) && vectorLayer 
      //     && vectorLayer.getSource().getFeatures().length > 0) {
      var features = vectorLayer.getSource().getFeatures();

      if (features && features.length > 0) {
        //retrieve the first feature and its properties
        var feature = features[0];
        var properties = feature.getProperties();
        var geometryName = feature.getGeometryName();
        var gridColumnDefs = []; //build grid properties ignoring geometry property

        for (var field in properties) {
          if (field !== geometryName) {
            gridColumnDefs.push({
              field: field,
              sortable: true,
              filter: true,
              resizable: true
            });
          }
        }

        setCurrentColumnDefs(gridColumnDefs);
      }
    }
  }, [currentColumnDefs]);
  /**
   * Event Handler fired when the grid is ready.
   * This handler will initialize the grid api 
   * in the state
   */

  var onInternalGridReady = (0, _react.useCallback)(function (params) {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    params.api.sizeColumnsToFit();
    onGridReady && onGridReady(params);
  }, [onGridReady]);
  /**
   * Event handler called when the selection has been changed.
   * This handler will highlight in the map the selected 
   * feature and un-highlight the unselected ones.
   * 
   * @param {*} evt The SelectionChangedEvent
   */

  var onInternalSelectionChanged = (0, _react.useCallback)(function (evt) {
    //retrieve the selected features
    var newSelectedRows = null;

    if (!_gridApi) {
      newSelectedRows = evt.api.getSelectedRows();
    } else {
      newSelectedRows = _gridApi.getSelectedRows();
    }

    var newSelectedFeatures = newSelectedRows.map(function (row) {
      return row.__feature;
    }); //unhighlight the previous features

    _selectedFeatures.forEach(function (feature) {
      if (!newSelectedFeatures.includes(feature)) {
        feature.setStyle(null);
      }
    }); //highlight the new features


    newSelectedFeatures.forEach(function (feature) {
      if (!_selectedFeatures.includes(feature)) {
        feature.setStyle(selectedFeatureStyle); //feature.set('GEN', feature.get('GEN') + 'A');
        //vectorLayer.getSource().removeFeature(feature);
      }
    }); //update state

    setSelectedFeatures(newSelectedFeatures); //fire event

    onSelectionChanged && onSelectionChanged(evt);
  }, [_selectedFeatures, selectedFeatureStyle, _gridApi, onSelectionChanged]);
  /**
   * To Zoom to the Layer during the initialization
   */

  (0, _react.useEffect)(function () {
    if (zoomToLayer && vectorLayer && vectorLayer.getSource().getFeatures().length > 0) {
      (0, _map.zoomToLayer)(map, vectorLayer);
    }
  }, [map, zoomToLayer, vectorLayer]);
  /**
   * Set the initial style for the layer
   * (or change to set for the feature ??)
   */

  (0, _react.useEffect)(function () {
    if (vectorLayer && featureStyle) {
      vectorLayer.setStyle(featureStyle);
    }
  }, [featureStyle, vectorLayer]);
  /**
   * Build the column definitions and the row data based on
   * the features present in the vector layer and its properties
   */

  (0, _react.useEffect)(function () {
    buildColumnDefs(vectorLayer);
    var data = buildRowDataFromLayer(vectorLayer);
    setRowData(data);
  }, [buildColumnDefs, buildRowDataFromLayer, vectorLayer]);
  /**
   * Register the event handlers for the ol objects:
   * (a) Register 'propertychange' for all the features in the layer
   */

  (0, _react.useEffect)(function () {
    if (vectorLayer) {
      registerFeaturePropertyChange(vectorLayer.getSource().getFeatures());
    }

    return function () {
      if (vectorLayer) {
        unRegisterFeaturePropertyChange(vectorLayer.getSource().getFeatures());
      }
    };
  }, [registerFeaturePropertyChange, unRegisterFeaturePropertyChange, vectorLayer]);
  /**
   * Register/Unregister the event handlers for the collection of features in the layer:
   * (a) Register 'add', 'remove' and 'clear' event handlers  for the 
   * collection of features in the layer
   */

  (0, _react.useEffect)(function () {
    if (vectorLayer) {
      registerLayerEventHandlers(vectorLayer);
    }

    return function () {
      if (vectorLayer) {
        unRegisterLayerEventHandlers(vectorLayer);
      }
    };
  }, [registerLayerEventHandlers, unRegisterLayerEventHandlers, vectorLayer]);
  var defaultColDef = (0, _react.useMemo)(function () {
    return {
      sortable: true,
      resizable: true,
      filter: true,
      flex: 1,
      minWidth: 100,
      headerComponentParams: {
        menuIcon: 'fa-bars'
      }
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_agGridReact.AgGridReact, _objectSpread(_objectSpread({}, otherProps), {}, {
    className: className,
    onGridReady: onInternalGridReady,
    onSelectionChanged: onInternalSelectionChanged,
    onRowClicked: onRowClicked,
    rowSelection: rowSelection,
    enableCellTextSelection: true,
    getRowId: getRowId,
    columnDefs: currentColumnDefs,
    defaultColDef: defaultColDef,
    rowData: _rowData
  }));
};

FeatureGrid.propTypes = {
  /**
   * The OpenLayers map <i>ol/Map</i> where the features will be rendered.
   */
  map: _propTypes.default.instanceOf(_Map.default).isRequired,

  /**
   * The OpenLayers vector layer <i>ol/layer/Vector</i> 
   * where the feature will be rendered.
   */
  vectorLayer: _propTypes.default.instanceOf(_Vector.default).isRequired,

  /**
   * The class name to provide different themes.
   * Check the  <a href="https://www.ag-grid.com/react-grid/themes-provided/">available themes.</a>
   * details about available themes.
   */
  className: _propTypes.default.string,

  /**
  * <p>Array of <a href="https://www.ag-grid.com/react-grid/grid-properties">Column Definitions.</a></p>
  * <p>
  *  If it is a empty array, all the property names will be shown
  *  in the grid.
  * </p>
  */
  columnDefs: _propTypes.default.array,

  /**
   * The openLayers style <i>ol/Style</i> used to render the
   * <u>unselected</u> feature(s) in the row grid.
   */
  featureStyle: _propTypes.default.instanceOf(_Style.default),

  /**
   * The openLayers style <i>ol/Style</i> used to render the
   * <u>selected</u> feature(s) in the row grid.
   */
  selectedFeatureStyle: _propTypes.default.instanceOf(_Style.default),

  /**
   * If true, the map will we zoomed to the features in the 
   * layer <i>vectorLayer</i> during the initialization;
   */
  zoomToLayer: _propTypes.default.bool,

  /**
   * Function to provide a unique identifer for the feature in the map.
   * The default function returns your internal unique identifier (uid).
   */
  keyFunc: _propTypes.default.func,

  /**
   * Allow a single or multiple row selection in the grid.
   */
  rowSelection: _propTypes.default.oneOf(['single', 'multiple']),

  /**
   * Event Handler for the event fired once the grid was
   * initialised.
   */
  onGridReady: _propTypes.default.func,

  /**
   * Event Handler for the event fired once the user selects 
   * one or more rows in the grid. See example below to check
   * how it works.
   */
  onSelectionChanged: _propTypes.default.func,

  /**
   * Event Handler for the event fired once a row in the
   * grid is selected.
   */
  onRowClicked: _propTypes.default.func
};
FeatureGrid.MenuBar = _FeatureGridMenuBar.default;
var _default = FeatureGrid;
exports.default = _default;